import React from 'react'

import { Link } from 'gatsby'

import Image from '@components/Content/WordPress/Image'

import { wpPostCardType } from '@contracts/wp/wpPosts'

import * as styles from './BlogCard.module.scss'

import ArrowRight from '@icons/arrow-right-red.svg'
import ArrowRightWhite from '@icons/arrow-right-white.svg'

interface Props {
	data: wpPostCardType
}

const NewsCard: React.FunctionComponent<Props> = ({ data }: Props) => {
	const [isHovered, setIsHovered] = React.useState<boolean>(false)
	const cardRef = React.useRef<HTMLDivElement>(null)

	const icon = isHovered ? <ArrowRightWhite className={styles.arrow} /> : <ArrowRight className={styles.arrow} />

	React.useEffect(() => {
		const card = cardRef.current

		if (card) {
			card.addEventListener('mouseenter', () => {
				setIsHovered(true)
			})

			card.addEventListener('mouseleave', () => {
				setIsHovered(false)
			})
		}

		return () => {
			if (card) {
				card.removeEventListener('mouseenter', () => {
					setIsHovered(true)
				})

				card.removeEventListener('mouseleave', () => {
					setIsHovered(false)
				})
			}
		}
	}, [])

	const title = data.title
	const image = data.featuredImage.node

	return (
		<div className={styles.card} ref={cardRef}>
			{image && (
				<div className={styles.imageContainer}>
					<Link to={'/insights' + data.uri} title={title}>
						<Image image={image} altText={data.title} />
					</Link>
				</div>
			)}

			<div className={styles.meta}>
				<Link to={'/insights' + data.uri} className={styles.link} title={title}>
					<h3 className={styles.title}>{title}</h3>
					{icon}
				</Link>
			</div>
		</div>
	)
}

export default NewsCard
